module.exports = __webpack_public_path__ + "img/Sort Icon - white.63f79d86.svg";